import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ReportVariation($id: ID!, $reason: String!, $comment: String) {
    reportVariation(id: $id, reason: $reason, comment: $comment) {
      id
      refundedCount
    }
  }
`;

export const reportVariation = (id, reason, comment) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id, reason, comment },
  }).then(({ data }) => getSingleProp(data));
